import { AppService } from './app.service';
import { AuthService } from './auth.service';
import { RoundsService } from './rounds.service';
import { UsersService } from './users.service';
import { LangService }  from './lang.service';
import { SettingsService } from './settings.service';

export {
  AppService,
  AuthService,
  RoundsService,
  UsersService,
  LangService,
  SettingsService,
};

export type Services =
  | AppService
  | AuthService
  | RoundsService
  | UsersService
  | LangService
  | SettingsService

const context = new Map(); // keeps instances of services

export const getService = <T extends any>(Service: new () => T): T => {
  if (context.has(Service)) {
    return context.get(Service);
  }
  const service = new Service();
  context.set(Service, service);
  return service;
};
